export { default as Button } from "@mui/material/Button"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton } from "./IconButton";

export const PrevButton = (props) => {
    return (
        <IconButton size="small" {...props} sx={{...styles.container, ...props.style}}>
            <ChevronLeftIcon />
        </IconButton>
    )
}

export const NextButton = (props) => {
    return (
        <IconButton size="small" {...props} sx={{...styles.container, ...props.style}}>
            <ChevronRightIcon />
        </IconButton>
    )
}

const styles = {
    container: {
        backgroundColor: '#FFF', 
        margin: 1
    }
}